import { render, staticRenderFns } from "./SuccessfullRegistration.vue?vue&type=template&id=a3cbfdd2&scoped=true"
import script from "./SuccessfullRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessfullRegistration.vue?vue&type=script&lang=js"
import style0 from "./SuccessfullRegistration.vue?vue&type=style&index=0&id=a3cbfdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cbfdd2",
  null
  
)

export default component.exports